import React, { memo, useState } from "react";
import { SwitchCityOtherDropdownWrapper } from "./style";
import { Divider, Dropdown } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getChangeCityAction } from "../../../global/store/actionCreators";
import KTDropdownCurrentLocationCell from "../switch-city-dropdown/c-components/current-location-cell";
import KTDropdownAnyLocationCell from "../switch-city-dropdown/c-components/any-location-cell";
import KTDropdownMatchingCell from "../switch-city-dropdown/c-components/matching-cell";
import { getLocation } from "../../../services/location";
import KTSearchInputCell from "../switch-city-dropdown/c-components/search-input";
import KTDropdownNoMatchingCell from "../switch-city-dropdown/c-components/no-matches-cell";

const KTSwitchCityOtherDropdown = memo((props) => {
  const [searchKeywords, setSearchKeywords] = useState("");
  const [arrResults, setArrResults] = useState([]);

  const { maxWidth = Infinity } = props;

  const { locationCity = {} } = useSelector(
    (state) => ({
      locationCity: state.getIn(["global", "locationCity"]),
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const onCellItemClick = (e) => {
    switch (e.key) {
      case "1":
        dispatch(getChangeCityAction(locationCity));

        break;
      case "2":
        dispatch(getChangeCityAction({}));

        break;
      default:
        const element = arrResults[e.key - 3];
        dispatch(getChangeCityAction(element));

        break;
    }
  };

  var items = [
    {
      label: <KTDropdownCurrentLocationCell />,
      key: 1,
    },
    {
      type: "divider",
    },
  ];

  if (searchKeywords.length === 0) {
    items.push({
      label: <KTDropdownAnyLocationCell />,
      key: 2,
    });

    items.push({
      type: "divider",
    });
  } else {
    arrResults.forEach((e, index) => {
      const title = `${e.postalCode}, ${e.name}, ${e.state}, ${e.country}`;
      items.push({
        label: <KTDropdownMatchingCell title={title} />,
        key: index + 3,
      });

      items.push({
        type: "divider",
      });
    });
  }

  const onSearchKeyChange = (value) => {
    setSearchKeywords(value);

    getLocation(value, (res) => {
      const r_list = res.list;

      setArrResults(r_list);
    });
  };

  function dropdownRender(menu) {
    return (
      <SwitchCityOtherDropdownWrapper maxWidth={maxWidth}>
        <KTSearchInputCell onValueChange={onSearchKeyChange} />
        {React.cloneElement(menu, {
          style: { boxShadow: "none" },
        })}
        {searchKeywords.length > 0 && arrResults.length === 0
          ? [<KTDropdownNoMatchingCell />, <Divider style={{ margin: 0 }} />]
          : null}
      </SwitchCityOtherDropdownWrapper>
    );
  }
  return (
    <Dropdown
      autoAdjustOverflow={false}
      destroyPopupOnHide={false}
      placement={"bottomLeft"}
      trigger={["click"]}
      menu={{ items, onClick: onCellItemClick, selectable: true }}
      dropdownRender={dropdownRender}
    >
      {props.children}
    </Dropdown>
  );
});

export default KTSwitchCityOtherDropdown;
